// extracted by mini-css-extract-plugin
export var gif = "_m8-0";